<template>
    <UiCard v-if="auction && auction.id" interactive class="flex items-center text-xs" @click="open">
        <div class="grow-0 shrink-0 px-4 py-2 font-semibold truncate w-28">
            {{ auction.reference_number ?? auction.id }}
        </div>
        <div class="flex-auto py-2">
            <div>
                {{ auction.type_label }}
            </div>
            <div class="font-semibold">
                {{ auction.title }}
            </div>
            <div>
                {{ auction.region ? lang(`auctions::auctions.fields.region_options.${auction.region}`) : '' }}
            </div>
            <div>{{ lang('auctions::auctions.fields.start_date') }}: {{ auction.start_date_label }}</div>

            <div>{{ lang('auctions::auctions.fields.end_date') }}: {{ auction.end_date_label }}</div>
            <div v-if="auction.participants_count !== undefined">
                {{ lang('auctions::auctions.fields.participants_count') }}:
                <span
                    :class="{
                        'font-bold text-orange-600':
                            auction.participants_count > PARTICIPANTS_THRESHOLD_WARNING &&
                            auction.participants_count <= PARTICIPANTS_THRESHOLD_CRITICAL,
                        'font-bold text-purple-600': auction.participants_count > PARTICIPANTS_THRESHOLD_CRITICAL,
                    }"
                >
                    {{ auction.participants_count }}
                </span>
            </div>
        </div>
        <div class="flex-auto contents">
            <slot></slot>
        </div>
        <div class="grow-0 pr-2">
            <span
                v-if="auction.state"
                :class="`px-2 py-1 bg-${auction.state_color}-200 dark:bg-${auction.state_color}-800 text-${auction.state_color}-800 dark:text-${auction.state_color}-200 rounded-full inline-block text-xs font-medium`"
            >
                {{ auction.state }}
            </span>
        </div>
    </UiCard>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { Auction } from '@src/Auctions/Pages/types';
import { router } from '@inertiajs/vue3';

interface Props {
    auction?: Auction | null;
}

const props = withDefaults(defineProps<Props>(), {
    auction: null,
});

const PARTICIPANTS_THRESHOLD_WARNING = 10;
const PARTICIPANTS_THRESHOLD_CRITICAL = 20;

const auction = toRef(props, 'auction');

const open = (): void => {
    router.visit(route('auctions.admin.panel', { id: auction.value.id }));
};
</script>
